import type { ReactNode } from "react";
import type { ContentItem } from "@/types/content";
import type { MediaController } from "./adapters/types";
import { useMediaAdapter } from "./adapters/useMediaAdapter";
import { MediaControllerContext } from "./context/MediaControllerContext";

interface MediaPlayerHostProps {
  content: ContentItem;
  signedUrl: string | null;
  children: (controller: MediaController | null, adapterProps: AdapterProps) => ReactNode;
}

export interface AdapterProps {
  ref?: React.RefObject<HTMLMediaElement>;
  containerId?: string;
  src: string;
}

export function MediaPlayerHost({ content, signedUrl, children }: MediaPlayerHostProps) {
  const type = content.type as "youtube" | "video" | "audio" | "recording";
  const src = type === "youtube" ? content.sourceUrl : signedUrl;

  const { controller, ref, containerId } = useMediaAdapter(type, src ?? null);

  const adapterProps: AdapterProps = {
    ref,
    containerId,
    src: src ?? "",
  };

  return (
    <MediaControllerContext.Provider value={controller}>
      {children(controller, adapterProps)}
    </MediaControllerContext.Provider>
  );
}
